import { useCallback, useEffect, useState } from 'react';
import { notificationsApi } from '../lib/api';

// Shared across mounts so the nav dot and the dashboard's "needs you" cards
// read the same data instead of each polling the endpoint themselves.
let cache = { at: 0, notifications: null };

export const useNotifications = () => {
  const [notifications, setNotifications] = useState(cache.notifications || []);

  const refresh = useCallback(async () => {
    try {
      const res = await notificationsApi.getAll();
      const list = res.data.notifications || [];
      cache = { at: Date.now(), notifications: list };
      setNotifications(list);
    } catch {
      // best-effort — the dot and cards just keep showing the last known state
    }
  }, []);

  useEffect(() => {
    const fresh = Date.now() - cache.at < 30_000;
    if (!fresh || cache.notifications === null) refresh();
    const interval = setInterval(refresh, 30_000);
    return () => clearInterval(interval);
  }, [refresh]);

  const markRead = useCallback((id) => {
    setNotifications((prev) => {
      const next = prev.map((n) => (n.id === id ? { ...n, read: true } : n));
      cache = { at: cache.at, notifications: next };
      return next;
    });
    notificationsApi.markRead(id).catch(() => { /* best-effort */ });
  }, []);

  return { notifications, refresh, markRead };
};

export default useNotifications;
